import React from 'react'
import logo from '../images/imageAssets/Main-Logo.png'

function Footer() {
  return (
    <div id='Footer' className='footerSection container'>
      <img className='footer-image' src={logo} alt="" srcset="" />
    </div>
  )
}

export default Footer